import './form.component.scss'

const checkboxes = document.querySelectorAll('.required-checkboxes input[type="checkbox"]')
// always enabled checkbox in group
checkboxes.forEach(checkbox => {
  checkbox.addEventListener('change', e => {
		const enabledChecked = [...checkboxes].filter(cb => cb.checked && !cb.disabled)

    if (enabledChecked.length === 0 && !e.target.checked) {
      e.preventDefault()
      e.target.checked = true
    }
  })
})
